import { useMemo } from "react";
import ServicePageTemplate from "@/pages/services/components/ServicePageTemplate";
import BangaloreCoverageMap from "@/pages/services/components/BangaloreCoverageMap";
import StructuredData from "@/components/feature/StructuredData";
import { getServiceDetail } from "@/mocks/services";
import { contactInfo } from "@/mocks/site";
import { absoluteUrl } from "@/utils/schemaBuilders";

const PAGE_URL = "https://laharipackersandmovers.in/services/local-shifting";

export default function LocalShiftingPage() {
  const detail = getServiceDetail("local-shifting");

  const schema = useMemo(() => {
    const areas = detail?.areas ?? [];
    return {
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Local Shifting Service",
      name: "Local Shifting Service in Bangalore",
      description:
        "Same-city household and office shifting across every major residential locality in Bangalore, including Nagarabhavi, Rajajinagar, Malleswaram, Jayanagar, JP Nagar, HSR Layout, Whitefield and Yelahanka.",
      url: PAGE_URL,
      provider: {
        "@type": "MovingCompany",
        name: contactInfo.brand,
        image: absoluteUrl(contactInfo.logo),
        telephone: contactInfo.phone,
        address: {
          "@type": "PostalAddress",
          streetAddress: "Anikethana Nagara, Kannahalli",
          addressLocality: "Bengaluru",
          addressRegion: "Karnataka",
          postalCode: "560112",
          addressCountry: "IN",
        },
      },
      areaServed: areas.map((area) => ({
        "@type": "Place",
        name: `${area.name}, Bangalore`,
      })),
    };
  }, [detail]);

  const faqSchema = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: (detail?.faqs ?? []).map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.a,
        },
      })),
    }),
    [detail],
  );

  if (!detail) return null;

  return (
    <>
      <StructuredData id="ld-local-shifting-area-served" data={schema} />
      <StructuredData id="ld-local-shifting-faq" data={faqSchema} />
      <ServicePageTemplate detail={detail} areaMap={<BangaloreCoverageMap />} />
    </>
  );
}